import React, { useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import ClientReviews from "./client/ClientReviews";
import DriverReviews from "./driver/DriverReviews";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useNavigate } from "react-router-dom";
import back from "../../assets/images/svg/back.svg";
import Filter from "../../components/Filter";
import { clientFilters, reviewFilter } from "../../utils/filterConfig";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export default function Reviews() {
  const [filtrationData, setFiltrationData] = useState({
    from: "",
    to: "",
  });
  const [dateFilter, setDateFilter] = useState({ from: "", to: "" });

  const [topReviews, setTopReviews] = useState([]);
  const [value, setValue] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const handleViewAllReviewsClick = () => {
    setShowAll(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setDateFilter({ from: "", to: "" });
  };

  const addReviewToTop = (review) => {
    setTopReviews((prevReviews) => {
      if (prevReviews.some((r) => r.id === review.id)) {
        return prevReviews;
      }
      if (prevReviews.length < 3) {
        return [...prevReviews, review];
      }
      return [review, ...prevReviews.slice(0, 2)];
    });
  };

  const handleBackClick = () => {
    setShowAll(false);
  };

  const getFilteredData = (data) => {
    setFiltrationData({
      ...filtrationData,
      ...data,
    });
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Grid container spacing={2} sx={{ padding: "0 18px" }}>
        <Box
          display="flex"
          alignItems={"center"}
          gap={"10px"}
          mt={"20px"}
          width={"100%"}
          position={"relative"}
          paddingX={"16px"}
          justifyContent={showAll ? "space-between" : "normal"}
        >
          <Box position={showAll ? "inherit" : "absolute"}>
            {(value === 0 && showAll) || (value === 1 && showAll) ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "flex-start",
                  gap: 1,
                }}
              >
                <IconButton
                  onClick={handleBackClick}
                  sx={{ marginLeft: "-10px" }}
                >
                  <img src={back} />
                </IconButton>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      fontSize: "30px",
                      color: "#673C8E",
                    }}
                  >
                    All Reviews
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "24px",
                  color: "#673C8E",
                }}
              >
                Top Reviews
              </Typography>
            )}
          </Box>
          <Box marginX={showAll ? "0px" : "auto"}>
            <Box
              sx={{
                bgcolor: "rgba(104, 60, 140, 0.06)",
                borderRadius: "8px",
                padding: "8px 10px",
                minHeight: "60px",
                maxHeight: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                centered
                sx={{
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Tab
                  label="Drivers"
                  sx={{
                    textTransform: "capitalize",
                    color: value === 0 ? "#fff" : "#000",
                    fontSize: "14px",
                    fontWeight: 700,
                    backgroundColor: value === 0 ? "#673C8E" : "transparent",
                    borderBottom: "none",
                    borderRadius: "16px",
                    minWidth: "67px",
                    width: "67px",
                    maxWidth: "67px",
                    minHeight: "34px",
                    height: "34px",
                    maxHeight: "34px",
                    mr: 2,
                  }}
                />
                <Tab
                  label="Clients"
                  sx={{
                    textTransform: "capitalize",
                    color: value === 1 ? "#fff" : "#000",
                    fontSize: "14px",
                    fontWeight: 700,
                    backgroundColor: value === 1 ? "#673C8E" : "transparent",
                    borderBottom: "none",
                    borderRadius: "16px",
                    minWidth: "67px",
                    width: "67px",
                    maxWidth: "67px",
                    minHeight: "34px",
                    height: "34px",
                    maxHeight: "34px",
                  }}
                />
              </Tabs>
            </Box>
          </Box>
          {showAll && (
            <Box
              display={"flex"}
              alignItems={"center"}
              gap="10px"
              justifyContent={"end"}
            >
              <Box
                sx={{
                  width: "190px",
                  paddingLeft: "6px",
                  display: "flex",
                  borderRadius: "4px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                  // border: "2px solid rgba(103, 60, 142, 1)",
                }}
              >
                <Typography
                  sx={{ color: "#673C8E", fontSize: "16px", fontWeight: 400 }}
                >
                  From
                </Typography>
                <LocalizationProvider
                  sx={{
                    "& .PrivatePickersPopperRoot-popupIndicator": {
                      display: "none",
                    },
                  }}
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    format="DD MMM YYYY"
                    value={dateFilter.from ? dayjs(dateFilter.from) : null}
                    maxDate={dateFilter.to ? dayjs(dateFilter.to) : null}
                    onChange={(date) => {
                      if (!dayjs(date).isValid()) return;
                      setDateFilter((dateFilter) => ({
                        ...dateFilter,
                        from: new Date(
                          new Date(date).setHours(0, 0, 0, 0)
                        ).toISOString(),
                      }));
                    }}
                    slotProps={{
                      textField: {
                        placeholder: "DD MMM YYYY",
                      },
                    }}
                    // value={filtrationData?.from ? dayjs(filtrationData.from) : null}
                    // onChange={(newValue) => {
                    //   const formattedDate = dayjs(newValue).toISOString();
                    //   setFiltrationData({
                    //     ...filtrationData,
                    //     from: formattedDate,
                    //   });
                    //   // handleFilterChange("from", formattedDate);
                    // }}
                    PopoverProps={{ disableEnforceFocus: true }} // Disable enforcing focus
                    sx={{
                      "& .MuiInputBase-input": {
                        paddingRight: "4px",
                        padding: "7px",
                        fontSize: showAll ? "10px" : "14px",
                        height: "25px",
                        color: "#673C8E",
                        borderRadius: "14px",
                        border: "none", // Remove the border from the input
                      },
                      "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root": {
                        color: "#673C8E", // Change the color of the icon button
                      },
                      "& .MuiOutlinedInput-root": {
                        // borderRadius: "14px",
                      },
                      "& .MuiOutlinedInput-root fieldset": {
                        // border: "none",
                        border: "2px solid rgba(103, 60, 142, 1)",
                      },
                      "& .MuiOutlinedInput-root fieldset:hover": {
                        borderColor: "#673C8E", // Change border color on hover
                      },
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "#673C8E", // Change border color when focused
                      },
                    }}
                    renderInput={(params) => (
                      <TextField placeholder="Select Date" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Box
                sx={{
                  width: "170px",
                  paddingLeft: "6px",
                  display: "flex",
                  borderRadius: "4px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                  // border: "2px solid rgba(103, 60, 142, 1)",
                }}
              >
                <Typography
                  sx={{ color: "#673C8E", fontSize: "16px", fontWeight: 400 }}
                >
                  To
                </Typography>
                <LocalizationProvider
                  sx={{
                    "& .PrivatePickersPopperRoot-popupIndicator": {
                      display: "none",
                    },
                  }}
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    format="DD MMM YYYY"
                    value={dateFilter.to ? dayjs(dateFilter.to) : null}
                    minDate={dateFilter.from ? dayjs(dateFilter.from) : null}
                    onChange={(date) => {
                      if (!dayjs(date).isValid()) return;
                      setDateFilter((dateFilter) => ({
                        ...dateFilter,
                        to: new Date(
                          new Date(date).setHours(23, 59, 59, 999)
                        ).toISOString(),
                      }));
                    }}
                    slotProps={{
                      textField: {
                        placeholder: "DD MMM YYYY",
                      },
                    }}
                    // value={filtrationData?.from ? dayjs(filtrationData.from) : null}
                    // onChange={(newValue) => {
                    //   const formattedDate = dayjs(newValue).toISOString();
                    //   setFiltrationData({
                    //     ...filtrationData,
                    //     from: formattedDate,
                    //   });
                    //   // handleFilterChange("from", formattedDate);
                    // }}
                    PopoverProps={{ disableEnforceFocus: true }} // Disable enforcing focus
                    sx={{
                      "& .MuiInputBase-input": {
                        paddingRight: "4px",
                        padding: "7px",
                        fontSize: showAll ? "10px" : "14px",
                        height: "25px",
                        color: "#673C8E",
                        borderRadius: "14px",
                        border: "none", // Remove the border from the input
                      },
                      "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root": {
                        color: "#673C8E", // Change the color of the icon button
                      },
                      "& .MuiOutlinedInput-root": {
                        // borderRadius: "14px",
                      },
                      "& .MuiOutlinedInput-root fieldset": {
                        // border: "none",
                        border: "2px solid rgba(103, 60, 142, 1)",
                      },
                      "& .MuiOutlinedInput-root fieldset:hover": {
                        borderColor: "#673C8E", // Change border color on hover
                      },
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "#673C8E", // Change border color when focused
                      },
                    }}
                    renderInput={(params) => (
                      <TextField placeholder="Select Date" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          )}
        </Box>
        {/* <Grid
          item
          xs={12}
          md={2}
          sx={{ textAlign: "right", paddingRight: "18px" }}
        >
          <Filter
            onResetFilters={() => {
              setFiltrationData((prev) => ({
                from: "",
                to: "",
              }));
            }}
            onFilterData={getFilteredData}
            type="reviewFilter"
            url="reviewFilter"
            config={reviewFilter}
          />
        </Grid> */}
        {value === 0 && (
          <DriverReviews
            showAllReviews={showAll}
            onViewAllClick={handleViewAllReviewsClick}
            topReviews={topReviews}
            addReviewToTop={addReviewToTop}
            filtrationData={filtrationData}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
          />
        )}
        {value === 1 && (
          <ClientReviews
            showAllReviews={showAll}
            onViewAllClick={handleViewAllReviewsClick}
            topReviews={topReviews}
            addReviewToTop={addReviewToTop}
            filtrationData={filtrationData}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
          />
        )}
      </Grid>
    </DndProvider>
  );
}
